import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import { Toaster } from "./components/ui/sonner";
import AuthPage from "./pages/AuthPage";
import Dashboard from "./pages/Dashboard";
import AddMealPage from "./pages/AddMealPage";
import MealHistoryPage from "./pages/MealHistoryPage";
import RestaurantsPage from "./pages/RestaurantsPage";
import BottomNav from "./components/BottomNav";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen" style={{ background: '#F9F8F6' }}>
        <div className="animate-pulse text-lg" style={{ color: '#5E646E', fontFamily: 'DM Sans, sans-serif' }}>
          Loading...
        </div>
      </div>
    );
  }
  if (!user) return <Navigate to="/auth" replace />;
  return children;
}

function AppRoutes() {
  const { user, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen" style={{ background: '#F9F8F6' }}>
        <div className="animate-pulse text-lg" style={{ color: '#5E646E', fontFamily: 'DM Sans, sans-serif' }}>
          Loading...
        </div>
      </div>
    );
  }

  return (
    <>
      <Routes>
        <Route path="/auth" element={user ? <Navigate to="/" replace /> : <AuthPage />} />
        <Route path="/" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
        <Route path="/add" element={<ProtectedRoute><AddMealPage /></ProtectedRoute>} />
        <Route path="/history" element={<ProtectedRoute><MealHistoryPage /></ProtectedRoute>} />
        <Route path="/restaurants" element={<ProtectedRoute><RestaurantsPage /></ProtectedRoute>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      {user && <BottomNav />}
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Toaster position="top-center" />
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
